import React from 'react';
import CampoComboFuenteInformacion from '../../UI/campos/CampoComboFuenteInformacion.js';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import CampoEditableFecha from '../../UI/campos/CampoEditableFecha.js';
import CampoEditableFechaCampos from '../../UI/campos/CampoEditableFechaCampos.js';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import CampoEditableMultilinea from '../../UI/campos/CampoEditableMultilinea.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import LargoCampos from '../../largoCampos/LargoCampos.js';
import styles from '../EditarItemLista.module.css';

const CamposLinks = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Tipo</td>
        <td className={`${styles.valor}`}>
          <CampoComboParametro
            nombre={Campos.Link.TIPO_LINK}
            tipoParametro={TipoParametro.TIPO_LINK}
            estilo={`${styles.comboDatos}`}
            valor={item && item.tipoLink}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fuente</td>
        <td className={`${styles.valor}`}>
          <CampoComboFuenteInformacion
            nombre={Campos.Link.FUENTE_INFORMACION}
            estilo={`${styles.comboDatos}`}
            valor={item && item.fuenteInformacion}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Publicación</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.Link.FECHA_PUBLICACION}
            anio={item && item.anioPublicacion}
            mes={item && item.mesPublicacion}
            dia={item && item.diaPublicacion}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>URL</td>
        <td className={`${styles.valor}`}>
          <CampoEditableTexto
            nombre={Campos.Link.URL}
            valor={item && item.url}
            largo={LargoCampos.URL}
            editar={editar}
            width="24rem"
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Válido</td>
        <td className={`${styles.valor}`}>
          <CampoEditableCheck
            nombre={Campos.Link.VALIDO}
            checked={item && item.valido}
            editar={editar}
            onChange={onCampoChange}
          />
          <React.Fragment>
            <span className={`${styles.subtitulo}`}>Fecha validación</span>
            <CampoEditableFecha
              nombre={Campos.Link.FECHA_VALIDEZ}
              valor={item && item.fechaValidacion}
              editar={editar}
              actualizar={actualizar}
              onChange={onCampoChange}
            />
          </React.Fragment>
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Observaciones</td>
        <td className={`${styles.valor}`}>
          <CampoEditableMultilinea
            filas="3"
            columnas="46"
            nombre={Campos.NombreEstadio.OBSERVACIONES}
            valor={item && item.observaciones}
            largo={LargoCampos.OBSERVACIONES}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposLinks;
